import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

const ROLE_COLORS = {
  student: { primary: '#22C55E', primaryLight: '#E8F5E9', primaryDark: '#16A34A' },
  parent: { primary: '#AB47BC', primaryLight: '#F3E5F5', primaryDark: '#7B1FA2' },
};

const DEFAULT = { primary: '#4A7CFE', primaryLight: '#EEF2FF', primaryDark: '#3B6DE8' };

const useRoleTheme = () => {
  const { userData } = useAuth();

  useEffect(() => {
    const colors = ROLE_COLORS[userData?.role] || DEFAULT;
    const root = document.documentElement;
    root.style.setProperty('--color-primary', colors.primary);
    root.style.setProperty('--color-primary-light', colors.primaryLight);
    root.style.setProperty('--color-primary-dark', colors.primaryDark);
  }, [userData?.role]);
};

export default useRoleTheme;
